function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.346,
    height: 120,
    viewBox: "0 0 166.346 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "efve1gwiga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9207",
    transform: "translate(0 -.315)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h166.345v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10647",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#efve1gwiga)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46605",
    d: "M150.515 189.956H40v-83.909A2.047 2.047 0 0 1 42.047 104h106.421a2.047 2.047 0 0 1 2.047 2.047zm0 0",
    transform: "translate(-14.421 -95.411)",
    style: {
      fill: "#faebc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46606",
    d: "M40 416h110.515v6.14H40zm0 0",
    transform: "translate(-14.421 -327.595)",
    style: {
      fill: "#f5dcb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46607",
    d: "M267.164 270.885h-49.117a2.047 2.047 0 0 1-2.047-2.047V232h53.211v36.838a2.047 2.047 0 0 1-2.047 2.047zm0 0",
    transform: "translate(-145.397 -190.666)",
    style: {
      fill: "#a5cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46608",
    d: "M40 200v16.373a12.067 12.067 0 0 0 6.14-1.594 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.067 12.067 0 0 0 6.14 1.594V200zm0 0",
    transform: "translate(-14.421 -166.852)",
    style: {
      fill: "#f5dcb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46609",
    d: "M88 216h24.559v57.3H88zm0 0",
    transform: "translate(-50.142 -178.759)",
    style: {
      fill: "#a5cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46610",
    d: "M88 384h24.559v14.326H88zm0 0",
    transform: "translate(-50.142 -303.781)",
    style: {
      fill: "#dbd9dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46611",
    d: "M88 416h24.559v6.14H88zm0 0",
    transform: "translate(-50.142 -327.595)",
    style: {
      fill: "#c9c6ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46612",
    d: "M88 216v12.279a12.067 12.067 0 0 0 6.14-1.594 12.622 12.622 0 0 0 12.279 0 12.067 12.067 0 0 0 6.14 1.594V216zm0 0",
    transform: "translate(-50.142 -178.759)",
    style: {
      fill: "#8cb4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46613",
    d: "M128.934 436.093H2.047a2.047 2.047 0 0 1 0-4.093h126.887a2.047 2.047 0 0 1 0 4.093zm0 0",
    transform: "translate(15.346 -339.502)",
    style: {
      fill: "#c9c6ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46614",
    d: "M132.654 152H22.14L16 168.373h122.794zm0 0",
    transform: "translate(3.439 -131.132)",
    style: {
      fill: "#ff9ba0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46621",
    d: "M216 232v7.529a12.621 12.621 0 0 0 4.093.658 12.067 12.067 0 0 0 6.14-1.594 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.622 12.622 0 0 0 12.279 0 12.067 12.067 0 0 0 6.14 1.594V232zm0 0",
    transform: "translate(-145.397 -190.666)",
    style: {
      fill: "#8cb4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46622",
    d: "M16 216v4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093c0 2.26 2.749 4.093 6.14 4.093s6.14-1.833 6.14-4.093V216zm0 0",
    transform: "translate(3.439 -178.759)",
    style: {
      fill: "#ff8087"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46623",
    d: "M267.164 360.186h-49.117A2.047 2.047 0 0 1 216 358.14V352h53.211v6.14a2.047 2.047 0 0 1-2.047 2.046zm0 0",
    transform: "translate(-145.397 -279.967)",
    style: {
      fill: "#8cb4eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46624",
    d: "M88 368h24.559v4.093H88zm0 0",
    transform: "translate(-50.142 -291.874)",
    style: {
      fill: "#8cb4eb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46588",
    d: "M22.621 3.074a2.957 2.957 0 0 0 3.011 0L27.82 1.62a1.767 1.767 0 0 1 2.473.527L31.7 4.366a2.952 2.952 0 0 0 2.75 1.224l2.59-.439a1.766 1.766 0 0 1 2.046 1.486l.384 2.595a2.957 2.957 0 0 0 2.014 2.24l2.542.656a1.771 1.771 0 0 1 1.264 2.193l-.7 2.522a2.956 2.956 0 0 0 .93 2.865l2.063 1.637a1.769 1.769 0 0 1 .263 2.516l-1.675 2.022a2.954 2.954 0 0 0-.315 2.994l1.212 2.323a1.768 1.768 0 0 1-.781 2.406l-2.353 1.168a2.955 2.955 0 0 0-1.505 2.608L42.591 40a1.77 1.77 0 0 1-1.691 1.885L38.275 42a2.957 2.957 0 0 0-2.436 1.772l-.912 2.458a1.769 1.769 0 0 1-2.311 1.03l-2.444-.966a2.953 2.953 0 0 0-2.945.626l-1.835 1.874a1.77 1.77 0 0 1-2.53 0l-1.838-1.876a2.956 2.956 0 0 0-2.946-.626l-2.442.966a1.767 1.767 0 0 1-2.31-1.03l-.915-2.458A2.957 2.957 0 0 0 9.974 42l-2.622-.111A1.77 1.77 0 0 1 5.658 40l.164-2.619a2.957 2.957 0 0 0-1.506-2.608l-2.352-1.164a1.768 1.768 0 0 1-.782-2.409L2.4 28.878a2.95 2.95 0 0 0-.316-2.994L.408 23.86a1.767 1.767 0 0 1 .263-2.515l2.064-1.637a2.956 2.956 0 0 0 .93-2.865l-.706-2.523a1.769 1.769 0 0 1 1.264-2.191l2.543-.657a2.957 2.957 0 0 0 2.014-2.24l.384-2.595a1.767 1.767 0 0 1 2.046-1.486l2.59.439a2.95 2.95 0 0 0 2.75-1.224l1.406-2.219a1.767 1.767 0 0 1 2.474-.527z",
    transform: "translate(103.117 62.363)",
    style: {
      fill: "#01a685"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46589",
    d: "M121.575 106.263a15.61 15.61 0 1 1-15.61-15.608 15.611 15.611 0 0 1 15.61 15.608z",
    transform: "translate(21.277 -18.55)",
    style: {
      fill: "#01a685"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46590",
    d: "m168.327 203.534-6.248-6.249 2.082-2.083 4.167 4.166 9.372-9.373 2.082 2.083z",
    transform: "translate(-43.688 -108.529)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTick);
export default __webpack_public_path__ + "static/media/home_tick.ea9ad6d539114d1634d340fd8e88e87d.svg";
export { ForwardRef as ReactComponent };